import { Box, Heading, VStack, Text,Image,SimpleGrid,useColorModeValue , useBreakpointValue,useToast} from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout";
import { useNavigate } from "react-router-dom";
import { useState,useCallback,  } from "react";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; 
import { DomainDetails, OfferDetails } from '../../Platform/Common/types';
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Button,
  HStack,
  Icon,
  Flex,
  Badge,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import B2CMarkdownLongText from '../Components/B2CMarkDownLongText';
import bandpic from "../../resources/EDUVIC B2C Hero3.png";
import OfferCard from '../Components/OfferCard';
import { FaRegLightbulb, FaCheckCircle } from "react-icons/fa";


const FREE_PACK_BENEFITS = [
  "Unlimited attempts on every test",
  "Timed or untimed, your choice",
  "Fresh question order on every attempt",
  "Worked solutions for every question",
  "Topic-level performance analytics",
  "Score trend across your attempts",
];

const B2CDomainPage = () => {

 const { domainSlug } = useParams<{ domainSlug?: string }>();

  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const theme = useColorModeValue("light", "dark");
  const isMobile = useBreakpointValue({ base: true, md: false });

   const [domainDetails, setDomainDetails] = useState<DomainDetails>();
  
    const toast = useToast();
    const tableHeaderbg = useColorModeValue("gray.200", "gray.700");
  
    // Fetch enrolled students when tenant ID is set
        const fetchDomainDetails = useCallback(async () => {
        if (!domainSlug) return;

        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'https://default-url.com';
            const response = await axios.get(`${apiUrl}/b2c/public/domain/${domainSlug}`);
            setDomainDetails(response.data);
        } catch (error) {
            console.error("Failed to load B2C Domain", error);
        }
        }, [domainSlug]);
  
  useEffect(() => {
    fetchDomainDetails();
  }, [fetchDomainDetails]);

useEffect(() => {
  if (!domainDetails) return;

  const title =
    domainDetails.meta_title ??
    domainDetails.hero_headline ??
    "Default Title";

  document.title = title;

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      domainDetails.meta_description ?? ""
    );
  }
}, [domainDetails]);

useEffect(() => {
  if (!domainSlug) return;

  let link = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = `https://eduvic.com.au/practice/${domainSlug}`;

  // Remove on leaving the page so other routes don't inherit this canonical
  return () => {
    link?.remove();
  };
}, [domainSlug]);
  
  const domainBg = useColorModeValue("blue.50", "gray.800");
  const offerBg = useColorModeValue("blue.100", "gray.800");

const { hash, pathname } = useLocation();

// Sections only exist after the domain details load
const sectionsReady = !!domainDetails;

useEffect(() => {
  if (hash) {
    // Data not loaded yet: the target doesn't exist, so wait instead of jumping to top.
    // The effect re-runs when sectionsReady flips to true.
    if (!sectionsReady) return;

    const element = document.querySelector(hash);
    if (element) {
      const yOffset = -80;
      const yPosition =
        element.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: yPosition, behavior: "smooth" });
      return;
    }
  }

  // No hash (or hash target doesn't exist) → reset to top
  window.scrollTo(0, 0);

}, [pathname, hash, sectionsReady]);


const handleCopyCoupon = async (code: string) => {
  try {
    await navigator.clipboard.writeText(code);
    toast({ title: "Coupon code copied", status: "success", duration: 2000, isClosable: true });
  } catch (err) {
    toast({ title: "Could not copy automatically", description: code, status: "info", duration: 4000, isClosable: true });
  }
};

// =========================
// FREE OFFERS
// =========================

const freeOffers =
  domainDetails?.offer_details
    ?.filter((offer) => offer.is_free)
    ?.sort(
      (a, b) => (a.sequence ?? 0) - (b.sequence ?? 0)
    ) ?? [];

// =========================
// PAID OFFERS
// =========================

const paidOffers =
  domainDetails?.offer_details
    ?.filter((offer) => !offer.is_free)
    ?.sort(
      (a, b) => (a.sequence ?? 0) - (b.sequence ?? 0)
    ) ?? [];

const freeOfferCardBg = useColorModeValue(
  "blue.50",
  "gray.800"
);
  return (
  <PublicLayout>
    <Box>

    {/* ================= HERO ================= */}

    <Box
      as="section"
      minH={{ base: "260px", md: "320px" }}
      bgImage={bandpic}
      bgSize="cover"
      // Mobile crops from the left side of the source image instead of
      // the right, so the logo/figure moves out of the text's way.
      // Desktop/tablet unchanged.
      bgPosition={{ base: "left center", md: "right center" }}
      bgRepeat="no-repeat"
      position="relative"
      overflow="hidden"
        >
      {/* LEFT Gradient Overlay for readability */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bgGradient="
          linear(
            to-r,
            rgba(0,0,0,0.68),
            rgba(0,0,0,0.35),
            rgba(0,0,0,0)
          )
        "
        zIndex={1}
      />

      {/* Content */}
      <Box
        position="relative"
        zIndex={2}
        minH={{ base: "260px", md: "320px" }}
        display="flex"
        alignItems="center"
        px={{ base: 6, md: 16 }}
      >
        <VStack
          align="flex-start"
          spacing={4}
          maxW="700px"
        >

          <Heading
            as="h1"
            color="white"
            size="2xl"
            lineHeight="1.2"
          >
            {domainDetails?.hero_headline}
          </Heading>

          {domainDetails?.hero_text && (
            <Text
              color="gray.100"
              fontSize={{ base: "md", md: "lg" }}
              lineHeight="1.7"
              maxW="650px"
            >
              {domainDetails.hero_text}
            </Text>
          )}

        </VStack>
      </Box>
    </Box>

      {/* PROMO BANNER */}
{/*       {(domainDetails?.promo_headline && domainDetails?.promo_active) && (
        <Box bg="purple.600" color="white" py="40px" px="24px" textAlign="center" mb={8}>
          <Heading size="lg">{domainDetails.promo_headline}</Heading>
          <Text mt={2}>{domainDetails.promo_text}</Text>
        </Box>
      )} */}
      {(domainDetails?.promo_headline && domainDetails?.promo_active) && (
        <Box bg="purple.600" color="white" py="40px" px="24px" textAlign="center" mb={8}>
          <Heading size="lg">{domainDetails.promo_headline}</Heading>
          {domainDetails.promo_text && <Text mt={2}>{domainDetails.promo_text}</Text>}

          {domainDetails.promo_coupon_code && (
            <VStack mt={4} spacing={3}>
              <Box border="2px dashed" borderColor="whiteAlpha.700" borderRadius="md" px={5} py={2} bg="purple.700">
                <Text fontWeight="bold" fontSize="lg" letterSpacing="wide">
                  {domainDetails.promo_coupon_code}
                </Text>
              </Box>
              <Button size="sm" bg="white" color="purple.700" _hover={{ bg: "gray.100" }} onClick={() => handleCopyCoupon(domainDetails.promo_coupon_code!)}>
                Copy Code
              </Button>
            </VStack>
          )}
        </Box>
      )}

      {/* ================= FREE OFFERS ================= */}
      {freeOffers.length > 0 && (
        <Box maxWidth="1600px" 
          id="free"
          scrollMarginTop="90px"
          marginLeft="auto" marginRight="auto" paddingLeft="16px" paddingRight="16px" marginBottom="40px">
          <Box borderRadius="2xl" overflow="hidden" bg={theme === "light" ? "green.50" : "green.700"} boxShadow="xl">
            <Box height="8px" bg="green.500" />
            <Box paddingTop="48px" paddingBottom="48px" paddingLeft="24px" paddingRight="24px">
              <VStack spacing={10}>
                <VStack spacing={3}>
                  <Heading size="xl">Free Practice Tests</Heading>
                  <Text color="gray.500" textAlign="center" maxW="2xl">
                    Try Eduvic with a free practice test in every subject, and attempt each
                    one as many times as you like.
                  </Text>
                </VStack>

                <VStack spacing={5} maxW="900px" mx="auto" width="100%" align="stretch">
                {freeOffers.map((offer) => {
                  const shortDescription = (offer as any).short_description as string | undefined;

                  return (
                    <Box
                      key={offer.offer_id}
                      borderWidth="1px"
                      borderRadius="2xl"
                      borderColor="gray.200"
                      bg={freeOfferCardBg}
                      p={{ base: 5, md: 8 }}
                      shadow="sm"
                      transition="all 0.25s ease"
                      _hover={{ shadow: "md", transform: "translateY(-2px)" }}
                    >
                      <Flex
                        direction={{ base: "column", lg: "row" }}
                        gap={{ base: 6, lg: 10 }}
                        align={{ base: "stretch", lg: "center" }}
                      >
                        {/* Left: what the pack is and what it includes */}
                        <VStack align="flex-start" spacing={4} flex={1}>
                          <HStack spacing={2} wrap="wrap">
                            <Badge colorScheme="green" fontSize="xs" px={3} py={1} borderRadius="full">
                              Free
                            </Badge>
                            {offer.duration_label && (
                              <Badge colorScheme="teal" fontSize="xs" px={3} py={1} borderRadius="full">
                                {offer.duration_label}
                              </Badge>
                            )}
                          </HStack>

                          <Heading as="h3" size="lg">{offer.name}</Heading>

                          {shortDescription && (
                            <Text color="gray.500" fontSize="md" lineHeight="1.7">
                              {shortDescription}
                            </Text>
                          )}

                          <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={8} spacingY={2} width="100%">
                            {FREE_PACK_BENEFITS.map((benefit) => (
                              <HStack key={benefit} spacing={2} align="flex-start">
                                <Icon as={FaCheckCircle} color="green.500" boxSize={4} mt="3px" flexShrink={0} />
                                <Text fontSize="sm" color={theme === "light" ? "gray.700" : "gray.100"}>
                                  {benefit}
                                </Text>
                              </HStack>
                            ))}
                          </SimpleGrid>
                        </VStack>

                        {/* Right: the call to action */}
                        <VStack spacing={3} flexShrink={0} minW={{ lg: "240px" }}>
                          <Button
                            size="lg"
                            colorScheme="teal"
                            px={10}
                            width={{ base: "100%", lg: "auto" }}
                            onClick={() => navigate(`/practice/${domainSlug}/${offer.slug}`)}
                          >
                            Start Free Practice Test
                          </Button>
                          <Text fontSize="xs" color="gray.500">
                            Free · No payment needed
                          </Text>
                        </VStack>
                      </Flex>
                    </Box>
                  );
                })}
                </VStack>
              </VStack>
            </Box>
          </Box>
        </Box>
      )}

      {/* ================= PAID OFFERS ================= */}
      {paidOffers.length > 0 && (
        <Box
          id="paid"
          scrollMarginTop="90px"
          maxWidth="1600px"
          marginLeft="auto"
          marginRight="auto"
          paddingLeft="16px"
          paddingRight="16px"
          marginBottom="40px"
        >
          <Box
            borderRadius="2xl"
            overflow="hidden"
            bg={theme === "light" ? "purple.50" : "purple.700"}
            boxShadow="xl"
          >
            <Box height="8px" bg="purple.500" />

            <Box
              paddingTop="56px"
              paddingBottom="56px"
              paddingLeft="24px"
              paddingRight="24px"
            >
              <VStack spacing={10}>
                <VStack spacing={3}>
                  <Heading size="xl">Premium Packages</Heading>

                  <Text
                    color="gray.500"
                    textAlign="center"
                    maxW="2xl"
                    fontSize="md"
                  >
                    Structured preparation packages with detailed analytics,
                    progressive practice, and full exam-focused learning support.
                  </Text>
                </VStack>

                {/* Maximum two offer cards per row */}
                <Box
                  width="100%"
                  display="grid"
                  gridTemplateColumns={{
                    base: "1fr",
                    lg: paidOffers.length === 1 ? "minmax(480px, 720px)" : "repeat(2, minmax(0, 1fr))",
                  }}
                  justifyContent="center"
                  gap={{ base: "24px", lg: "40px" }}
                >
                  {paidOffers.map((offer) => (
                    <Box
                      key={offer.offer_id}
                      width="100%"
                    >
                      <OfferCard
                        offer={offer}
                        domainSlug={domainSlug || ""}
                      />
                    </Box>
                  ))}
                </Box>
              </VStack>
            </Box>
          </Box>
        </Box>
      )}

      {/* LONG CONTENT */}
      <Box maxWidth="1600px" marginLeft="auto" marginRight="auto" paddingLeft="16px" paddingRight="16px" marginBottom="40px">
        <Box borderRadius="2xl" overflow="hidden" bg={theme === "light" ? "blue.50" : "blue.700"} boxShadow="xl">
          <Box height="8px" bg="blue.500" />
          <Box padding="32px">
            <B2CMarkdownLongText content={domainDetails?.long_description} />
          </Box>
        </Box>
      </Box>

      {/* FAQ */}
      {(domainDetails?.faq_json?.length ?? 0) > 0 && (
        <Box paddingTop="40px" paddingBottom="40px" paddingLeft="24px" paddingRight="24px">
          <VStack spacing={3} mb={10}>
            <Heading size="xl" textAlign="center">
              Frequently Asked Questions
            </Heading>
          </VStack>

          <VStack spacing={6} maxW="1200px" mx="auto" align="stretch">
            <Accordion allowToggle width="100%">
              {domainDetails?.faq_json?.map((faq, index) => (
                <AccordionItem key={index} border="1px solid" borderColor="gray.200" borderRadius="md" mb={3}>
                  <AccordionButton py={4}>
                    <HStack flex="1" spacing={3} align="center">
                      <Icon as={FaRegLightbulb} color="blue.500" boxSize={4} />
                      <Box textAlign="left" fontWeight="semibold">
                        {faq.question}
                      </Box>
                    </HStack>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4} color="gray.600">
                    {faq.answer}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </VStack>
        </Box>
      )}

    </Box>
  </PublicLayout>
);
}

export default B2CDomainPage;